import TopLogout from "../components/TopLogout";
import React from "react";
import BottomNav from "../components/BottomNav";

export default function Contact() {
  return (
    <div style={styles.bg}>

      {/* ⭐ COMPANY LOGO (TOP-LEFT) */}
      <img src="/com_logo.png" alt="Company Logo" style={styles.companyLogo} />

      <div style={styles.overlay}>
        <TopLogout />

        {/* TITLE */}
        <h1 style={styles.title}>Contact Us</h1>

        {/* ---------------- COMPANY FIRST ---------------- */}
        <h2 style={styles.sectionTitle}>Industry Partner</h2>

        <div style={styles.cardWide} className="contactCard">
          <h3 style={styles.name}>MEMBESYS TECHNOCRATS</h3>
          <p>Digitalization Our Passion...</p>

          <p>Email: mjembesys@gmail.com</p>

          <p>
            Website:{" "}
            <a
              href="https://www.mjembesys.in"
              target="_blank"
              rel="noopener noreferrer"
              style={styles.link}
            >
              www.mjembesys.in
            </a>
          </p>

          <p>Phone: 9890766696 / 9730924901</p>

          <p>
            Address: 2nd Floor, Deshpande Complex, Nandi Stop, Ausa Road,<br />
            Chhatrapati Shivaji Maharaj Chowk, Latur – 413512
          </p>
        </div>

        {/* ---------------- TEAM DETAILS ---------------- */}
        <h2 style={styles.sectionTitle}>Project Team</h2>

        <div style={styles.grid}>

          {/* 1 — POOJA */}
          <div style={styles.card} className="contactCard">
            <h3 style={styles.name}>Pooja Nanaware</h3>
            <p>Email: pooja.nanaware24@vit.edu</p>
            <p>Phone: +91 7841881991</p>
            <p>Location: Pune, Maharashtra</p>
          </div>

          {/* 2 — PRATIKSHA */}
          <div style={styles.card} className="contactCard">
            <h3 style={styles.name}>Pratiksha Bile</h3>
            <p>Email: pratiksha.bile24@vit.edu</p>
            <p>Phone: +91 8799880512</p>
            <p>Location: Pune, Maharashtra</p>
          </div>

          {/* 3 — OM */}
          <div style={styles.card} className="contactCard">
            <h3 style={styles.name}>Om Gaikwad</h3>
            <p>Email: om.gaikwad24@vit.edu</p>
            <p>Phone: +91 7020329618</p>
            <p>Location: Pune, Maharashtra</p>
          </div>

        </div>
      </div>

      <BottomNav />
    </div>
  );
}

/* -------------------------------- STYLES ------------------------------- */
const styles = {
  bg: {
    backgroundImage: "url('/bg6.png')",
    backgroundSize: "cover",
    backgroundPosition: "center",
    width: "100%",
    minHeight: "100vh",
  },

  /* ⭐ NEW LOGO STYLE */
  companyLogo: {
    position: "absolute",
    top: "10px",
    left: "10px",
    width: "140px",
    zIndex: 1000,
  },

  overlay: {
    background: "rgba(0,0,0,0.55)",
    minHeight: "100vh",
    padding: "20px",
    paddingBottom: "90px",
    textAlign: "center",
    color: "white",
  },

  title: {
    fontSize: "32px",
    fontWeight: "bold",
    marginBottom: "10px",
    color: "#a8ff60",
  },

  sectionTitle: {
    fontSize: "22px",
    fontWeight: "bold",
    marginTop: "20px",
    marginBottom: "15px",
    color: "#d8ffbe",
  },

  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
    gap: "18px",
    marginBottom: "20px",
  },

  card: {
    background: "rgba(0,0,0,0.35)",
    borderRadius: "14px",
    padding: "18px",
    backdropFilter: "blur(6px)",
    boxShadow: "0 4px 12px rgba(0,0,0,0.4)",
    transition: "all 0.25s ease",
    cursor: "pointer",
  },

  cardWide: {
    background: "rgba(0,0,0,0.35)",
    borderRadius: "14px",
    padding: "18px",
    margin: "20px auto",
    width: "90%",
    maxWidth: "500px",
    backdropFilter: "blur(6px)",
    boxShadow: "0 4px 12px rgba(0,0,0,0.4)",
    transition: "all 0.25s ease",
    cursor: "pointer",
  },

  name: {
    fontSize: "18px",
    fontWeight: "bold",
    color: "#9dff75",
    marginBottom: "8px",
  },

  link: {
    color: "#9dff75",
    fontWeight: "bold",
    textDecoration: "underline",
    cursor: "pointer",
  },
};

/* ------------------ Hover effect ------------------ */
setTimeout(() => {
  const sheet = document.styleSheets[0];
  sheet.insertRule(`
    .contactCard:hover {
      transform: translateY(-6px);
      box-shadow: 0 6px 18px rgba(0,0,0,0.55);
    }
  `, sheet.cssRules.length);
}, 50);
